/**
 * Klaviyo Back in Stock - Loading Fix
 * Ensures data attributes are set before Klaviyo's script runs
 */

(function() {
  'use strict';
  
  // Wrap in try-catch to survive if other scripts have broken the page
  try {
  
  // Function to initialize BIS trigger with proper data attributes
  function initializeKlaviyoBISTriggers() {
    const triggers = document.querySelectorAll('.klaviyo-bis-trigger');
    
    triggers.forEach(trigger => {
      // Skip if already initialized
      if (trigger.dataset.bisInitialized === 'true') return;
      
      // Get the closest Alpine component to access reactive data
      const alpineComponent = trigger.closest('[x-data]');
      
      if (alpineComponent && window.Alpine) {
        try {
          const alpineData = Alpine.$data(alpineComponent);
          
          // Set variant and SKU from Alpine data if not already set
          if (alpineData.defaultVariantId && !trigger.dataset.variant) {
            trigger.dataset.variant = alpineData.defaultVariantId;
          }
          
          if (alpineData.defaultVariantSKU && !trigger.dataset.sku) {
            trigger.dataset.sku = alpineData.defaultVariantSKU;
          }
          
          // Mark as initialized
          trigger.dataset.bisInitialized = 'true';
          
          // console.log('✓ Klaviyo BIS trigger initialized:', {
          //   product: trigger.dataset.product,
          //   variant: trigger.dataset.variant,
          //   sku: trigger.dataset.sku
          // });
        } catch (e) {
          console.warn('Could not access Alpine data for BIS trigger:', e);
        }
      }
    });
  }

  // Helper to get current variant id from the product form as a fallback
  function getCurrentVariantId() {
    const input = document.querySelector('form[action*="/cart/add"] input[name="id"]');
    if (input && input.value) return input.value;
    return undefined;
  }

  // Update BIS triggers on variant change (keeps Klaviyo in sync)
  function refreshBISTriggers() {
    const triggers = document.querySelectorAll('.klaviyo-bis-trigger');
    const variantId = getCurrentVariantId();
    triggers.forEach(trigger => {
      if (!trigger) return;
      if (!trigger.dataset.variant && variantId) {
        trigger.dataset.variant = variantId;
      }
    });

    // If no Klaviyo button is injected yet but triggers are visible, ask to re-init
    const visibleTriggers = Array.from(triggers).filter(t => t.offsetParent !== null);
    const hasButtons = document.querySelector('.klaviyo-bis-button-container');
    if (visibleTriggers.length > 0 && !hasButtons) {
      // If our bootstrapper is available, re-run it
      if (typeof window.__scgInitKlaviyoBIS === 'function') {
        try { window.__scgInitKlaviyoBIS(); } catch (_) {}
      } else {
        // Or emit a refresh event that the bootstrapper can listen for
        try { window.dispatchEvent(new CustomEvent('klaviyo:bis:refresh')); } catch (_) {}
      }
    }
  }
  
  // Try to initialize when Alpine is ready
  if (window.Alpine) {
    document.addEventListener('alpine:initialized', function() {
      console.log('Alpine initialized - setting up BIS triggers');
      initializeKlaviyoBISTriggers();
      
      // Re-initialize on variant changes (support multiple event names)
      const onVariantChange = () => {
        // Update attributes quickly, then try re-init if needed
        setTimeout(() => {
          refreshBISTriggers();
          initializeKlaviyoBISTriggers();
        }, 50);
      };
      document.addEventListener('variant:changed', onVariantChange);
      document.addEventListener('variant-change', onVariantChange);
      window.addEventListener('variant-change', onVariantChange);
    });
  }
  
  // Fallback: try after DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      setTimeout(initializeKlaviyoBISTriggers, 500);
      setTimeout(refreshBISTriggers, 600);
    });
  } else {
    setTimeout(initializeKlaviyoBISTriggers, 500);
    setTimeout(refreshBISTriggers, 600);
  }
  
  // Also listen for Klaviyo's own ready event
  window.addEventListener('klaviyoForms', function() {
    setTimeout(initializeKlaviyoBISTriggers, 100);
    setTimeout(refreshBISTriggers, 150);
  });
  
  // Observe for dynamically added triggers
  const observer = new MutationObserver(function(mutations) {
    let shouldInit = false;
    
    mutations.forEach(function(mutation) {
      mutation.addedNodes.forEach(function(node) {
        if (node.nodeType === 1) { // Element node
          if (node.classList && node.classList.contains('klaviyo-bis-trigger')) {
            shouldInit = true;
          } else if (node.querySelector && node.querySelector('.klaviyo-bis-trigger')) {
            shouldInit = true;
          }
        }
      });
    });
    
    if (shouldInit) {
      setTimeout(initializeKlaviyoBISTriggers, 100);
      setTimeout(refreshBISTriggers, 150);
    }
  });
  
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  // Also watch for changes to the variant input directly
  document.addEventListener('change', function(e) {
    const t = e.target;
    if (!t) return;
    if (t.matches('form[action*="/cart/add"] input[name="id"], variant-radios input, variant-selects select')) {
      setTimeout(() => {
        refreshBISTriggers();
        initializeKlaviyoBISTriggers();
      }, 50);
    }
  }, true);
  
  } catch (globalError) {
    // Log but don't break the page if this script fails
    console.error('Klaviyo BIS fix script error:', globalError);
  }
  
})();
